import { render, staticRenderFns } from "./BankAccountTypeView.vue?vue&type=template&id=61c960d3&scoped=true&"
import script from "./BankAccountTypeView.vue?vue&type=script&lang=ts&"
export * from "./BankAccountTypeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c960d3",
  null
  
)

export default component.exports